// ── Constants ────────────────────────────────────────────────────────────────

export const ENV_KEYS = ["dev", "staging", "production"] as const;
export type EnvKey = (typeof ENV_KEYS)[number];

export const ENV_LABELS: Record<EnvKey, string> = {
  dev: "Development",
  staging: "Staging",
  production: "Production",
};

export const ENV_COLORS: Record<
  EnvKey,
  "default" | "primary" | "secondary" | "error"
> = {
  dev: "default",
  staging: "primary",
  production: "secondary",
};

// ── Service resource defaults by type ────────────────────────────────────────

export const SERVICE_DEFAULTS: Record<
  string,
  { cpu: number; memory: number; storage: number }
> = {
  server: { cpu: 0.5, memory: 1, storage: 0 },
  static: { cpu: 0.1, memory: 0.25, storage: 0 },
  scheduler: { cpu: 0.5, memory: 1, storage: 0 },
  stateful: { cpu: 0.5, memory: 0.5, storage: 10 },
  cron: { cpu: 0.25, memory: 0.5, storage: 0 },
};

// ── Per-env service values ───────────────────────────────────────────────────

export interface EnvServiceValues {
  cpu: number;
  memory: number;
  storage: number;
  replicas: number;
}

/** Full service entry: identity + per-environment resource values */
export interface EditableService {
  name: string;
  type: string;
  internetFacing: boolean;
  /** Per-environment resource values. dev is the base; others are overrides. */
  environments: Record<EnvKey, EnvServiceValues>;
  /** Which environments are enabled for this service */
  enabledEnvs: Set<EnvKey>;
}
